import React, { FC } from 'react'
import s from './TechnicalSection.module.scss'
import { BACKEND_URL } from '../../../api'

interface TechnicalSectionProps {
    schemaImage?: string
    interactionsText?: string
    interactionsImage?: string
}

const TechnicalSection: FC<TechnicalSectionProps> = ({ schemaImage, interactionsText, interactionsImage }) => {
    if (!schemaImage && !interactionsText) return null

    return (
        <section className={s.technical}>
              
            <div className='container'>
                <div className={s.wrapper}>
                    {/* Схема подключения - слева */}
                    {schemaImage && (
                        <div className={s.block}>
                            <h2 className={`${s.title} title`}><span/>СХЕМА ПОДКЛЮЧЕНИЯ ДАТЧИКОВ И УСТРОЙСТВ К ПРИБОРУ  ПР205</h2>
                            <div className={s.schemaImage}>
                                <img src={BACKEND_URL + schemaImage} alt="Схема подключения" />
                            </div>
                        </div>
                    )}

                    {/* Взаимодействия - справа */}
                    {interactionsText && (
                        <div className={s.block}>
                            <h2 className={`${s.title} title`}>Взаимодействия с другими устройствами</h2>
                            <p className={s.text}>{interactionsText}</p>
                            {interactionsImage && (
                                <div className={s.interactionsImage}>
                                    <img src={BACKEND_URL + interactionsImage} alt="Взаимодействия" />
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </section>
    )
}

export default TechnicalSection

